import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrCouponDiscountType.ts
var t = () => e("couponDiscountType");
//#endregion
export { t as useTrCouponDiscountType };
